module.exports = __webpack_public_path__ + "static/media/tariffs.0b077591.png";